import { AlertColor } from '@mui/material';

export interface IToastState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

export const initialState: IToastState = {
  open: false,
  message: '',
  severity: 'success',
};
